import { z } from 'zod/v4';

/**
 * One field's movement inside a single save. The same shape for every entity
 * type, which is what lets one generic renderer show any entity's history;
 * per-entity meaning (labels, option names) is resolved by the reader from
 * `field`. A redacted field (media, address) carries `from`/`to` as null.
 */
export const FieldChangeSchema = z.object({
  field: z.string(),
  from: z.unknown(),
  to: z.unknown(),
});

export type FieldChange = z.infer<typeof FieldChangeSchema>;
